import { EmbeddedDashboard, } from './EmbeddedDashboard';
import { ComponentTypes, EditorPlacements, InteractivityProfile, VIS_TYPES, } from './types';
export const allowedVisTypesForLite = [
    VIS_TYPES.UBER_BARS,
    VIS_TYPES.MULTI_METRIC_BARS,
    VIS_TYPES.DONUT,
    VIS_TYPES.KPI,
    VIS_TYPES.BUBBLES,
    VIS_TYPES.PIE,
    VIS_TYPES.RAW_DATA_TABLE,
];
export class EmbeddedLiteDashboard extends EmbeddedDashboard {
    componentType = ComponentTypes.LITE_DASHBOARD;
    /**
     *
     * @param theme - The theme for the embedded dashboard. Valid values are `composer`, `modern`, or `dark`.
     * The initial default theme, `composer`, is the same as the `modern` theme.
     * However, if you add your own themes to the application, more options are available in this list and you may have introduced a different default.
     * @param application - `application.banner` Indicates whether the Composer top-level navigation banner should be shown with the embedded dashboard.
     * Valid values are `true` or `false`.
     *
     * `application.logo` Indicates whether the Composer logo should be shown with the embedded dashboard. Valid values are `true` or `false`.
     * @param renderer
     * @param dashboardId - The dashboard ID. If no dashboard ID is specified, an empty dashboard is embedded.
     *
     * @param header - `header.showActions` Indicates whether dashboard actions should be visible for the embedded dashboard. Valid values are `true` or `false`.
     *
     * `header.showTitle` Indicates whether the dashboard title should be shown for the embedded dashboard. Valid values are `true` or `false`.
     *
     * `header.title` Allows you to overwrite the title of the embedded dashboard. The embedded dashboard title is read only; it cannot be changed while the dashboard is embedded.
     *
     * `header.dashboardSettingsPlacement` Indicates how interactivity, dashboard filters and layout settings panels should looks like. Valid settings placements are `singlePanel` and `multiplePanels`. Applies when RESPONSIVE_LAYOUT toggle is on.
     *
     * header.visible Indicates whether the dashboard header should be shown for the embedded dashboard. Valid values are `true` or `false`.
     * @param suppressAutoLayoutWarning - Allows you to suppress visibility of convert layout banner. Valid values are `true` of `false`.
     * @param suppressResponsiveLayout - Allows you to suppress applying adaptive layout. Valid values are `true` of `false`.
     * @param hideRestrictedVisuals - Allows you to hide visuals that users do not have access to. Works with new dashboard layout.
     * @param editor - `editor.placement` Indicates where the dashboard editor appears. Valid editor placements are `dockRight` and `modals`.
     * @param interactivityProfileName - The name of the dashboard interactivity profile that should be used for the embedded lite dashboard. By default the component uses `LITE` profile.
     * @param interactivityOverrides - Specifies specific dashboard and visual interactivity settings for an embedded dashboard.
     * The visual interactivity settings specified in this object will override any interactivity settings specified for the individual
     * visuals. These settings will also override the dashboard interactivity profile linked to the dashboard
     * (the one saved with the dashboard) and the dashboard interactivity profile passed by the `interactivityProfileName` property.
     * @param notificationSettings - Specifies settings for notifications
     * @param menuEventsConfig - Specifies event setup for context visual menu
     * @param editorUserSettings - If `editorUserSettings.isViewMode` is true, then View mode is applied, which restricts some editing abilities (layout change, adding visuals, save, etc.). Default value is `false`.
     *
     * `editorUserSettings.canSwitchMode` Indicates whether the editor can switch between edit and view modes. Valid values are `true` or `false`. Default value is `true`.
     *
     * `editorUserSettings.allowInteractivityConfiguration` Indicates whether the editor can edit interactivity profile. Valid values are `true` or `false`. Default value is `false`.
     *
     * @param visualLegendType - Specifies Visual Legend type for embedded dashboard
     * In case of `staticLegend` - composer legend will be used.
     * In case of `dynamicLegend - Echarts legend will be used.
     * In other cases - legend type will be taken from feature toggle value
     * @param initialFilters - EXPERIMENTAL. Allows you to pass initial filters for a single source. Passing sourceId is required.
     * Time Filters and Filter could be passed together or separately and will be applied to the visuals that are using passed source.
     * @param availableVisTypes - Specifies an array of limited visual types for embedded lite dashboard. While adding a new visual in embedded *lite-dashboard* component, if the selected source does not support `RAW_DATA_TABLE`,
     * then these limited visual types will be displayed for opting. Also the available visual types in the *Visual Style Panel* will be limited to these visual types.
     *
     *  For embedded dashboard this is `undefined`.
     *
     * For embedded *lite-dashboard*, the default available visual types are `['UBER_BARS','MULTI_METRIC_BARS','DONUT','KPI','BUBBLES','PIE','RAW_DATA_TABLE']`.
     */
    constructor(theme, application, renderer, dashboardId, header, editor, interactivityProfileName, interactivityOverrides, notificationSettings, menuEventsConfig, suppressAutoLayoutWarning, suppressResponsiveLayout, hideRestrictedVisuals, editorUserSettings, visualLegendType, initialFilters, availableVisTypes) {
        super(theme, application, renderer, dashboardId, null, header, editor, interactivityProfileName, interactivityOverrides, notificationSettings, menuEventsConfig, suppressAutoLayoutWarning, suppressResponsiveLayout, hideRestrictedVisuals, editorUserSettings, visualLegendType, initialFilters, availableVisTypes);
        this.editor = editor || {
            placement: EditorPlacements.DOCK_RIGHT,
        };
        this.interactivityProfileName = interactivityProfileName || InteractivityProfile.LITE;
        if (availableVisTypes && availableVisTypes.length) {
            if (!availableVisTypes.includes('RAW_DATA_TABLE')) {
                this.availableVisTypes = ['RAW_DATA_TABLE', ...availableVisTypes];
            }
            else {
                this.availableVisTypes = availableVisTypes;
            }
        }
        else {
            this.availableVisTypes = allowedVisTypesForLite;
        }
        if (dashboardId === null) {
            this.route = `visualization/create/${this.componentInstanceId}?lite=true`;
        }
        else {
            this.route = `visualization/${dashboardId}/${this.componentInstanceId}?lite=true`;
        }
    }
}
//# sourceMappingURL=EmbeddedLiteDashboard.js.map